export const Operadoras = [
    {
        registro: "",
        razao: "",
        abreviatura: "A5",
    },
    {
        registro: "-",
        razao: "-",
        abreviatura: "-       -",
    },
    {
        registro: "000000",
        razao: "SISTEMA ÚNICO DE SAÚDE",
        abreviatura: "SUS",
    },
    {
        registro: "322571",
        razao: "UNIMED GUARAPUAVA COOPERATIVA DE TRABALHO MÉDICO",
        abreviatura: "UNIMED",
    },
    {
        registro: "355151",
        razao: "FUNDAÇÃO COPEL DE PREVIDÊNCIA E ASSISTÊNCIA SOCIAL",
        abreviatura: "FUND COPEL",
    },
    {
        registro: "372609",
        razao: "NOSSA SAÚDE ASSISTÊNCIA MÉDICA LTDA",
        abreviatura: "NOSSA SAÚDE",
    },
    {
        registro: "005711",
        razao: "BRADESCO SAÚDE",
        abreviatura: "BRADESCO",
    },
    {
        registro: "338648",
        razao: "FUNDAÇÃO SANEPAR DE ASSISTÊNCIA SOCIAL",
        abreviatura: "FUND SANEPAR",
    },
    {
        registro: "416584",
        razao: "ASSOCIAÇÃO FUNDO DE PROTEÇÃO À SAÚDE",
        abreviatura: "FUPS-COAMO",
    },
    {
        registro: "323080",
        razao: "GEAP AUTOGESTÃO EM SAÚDE",
        abreviatura: "GEAP",
    },
    {
        registro: "326305",
        razao: "AMIL ASSISTÊNCIA MÉDICA INTERNACIONAL S.A.",
        abreviatura: "AMIL",
    },
        {
        registro: "346659",
        razao: "CAIXA DE ASSISTÊNCIA DOS FUNCIONÁRIOS DO BANCO DO BRASIL",
        abreviatura: "CASSI",
    },
]